import { DecimalPipe } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { getShortDecimalFormat, Helper } from '@piqet-angular/data';
import { EN_LOCALE, reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';

@Component({
  selector: 'piqet-angular-report-scenario-detail',
  templateUrl: './report-scenario-detail.component.html',
  styleUrls: ['./report-scenario-detail.component.scss'],
})
export class ReportScenarioDetailComponent {
  @Input() impactItems: any;
  @Input() isExport: any;
  @Input() isProductContent: any;
  @Input() isExcludeProductImpacts: any;
  @Input() isApiCAll: boolean = false;
  @Input() processIncluded: any;
  @Input() scenarioDataList: any;
  isVisibleTransportReuseTable = false;
  transportDetail: any;
  showFillerTransport = false;
  reportResource = reportTitals;
  showAllMaterial: any = {
    isMaterial: true,
    isConversion: true,
    isFilling: true,
    isWholesale: true,
    isRetail: true,
    isConsumer: true,
    isProductMassIncluded: true,
    isProductLoss: true,
    isFullProductImpacts: true,
    isEOL: true,
    isPallet: true,
    isProductIncluded: true,
  };
  @Input() isCheckISO = false;
  @Input() isIsoReport = false;

  constructor(
    private helper: Helper,
    private decimalPipe: DecimalPipe,
    private reportService: ReportsService
  ) {}
  ngOnChanges(changes: SimpleChanges) {
    if (this.isCheckISO) {
      this.processIncluded = changes['processIncluded'].currentValue;
    } else {
      this.processIncluded = this.showAllMaterial;
    }
    this.impactItems = changes['scenarioDataList']?.currentValue;
    this.impactItems.reuseFillertransportationItems.map((data: any) => {
      if (data.reuseFillingtransportationItems.length > 0) {
        this.isVisibleTransportReuseTable = true;
      }
    });

    this.showFillerTransport = this.impactItems?.fillertransportationItems?.some(
      (item: any) =>
        item.fillingtransportationItems != null && item.fillingtransportationItems.length > 0
    );
  }

  async getScenarioDetails() {
    const response = await this.reportService.getScenarioDetails(
      this.impactItems.scenarioId,
      this.isExport,
      this.isProductContent,
      this.isExcludeProductImpacts
    );
    this.impactItems = response.data;
  }

  getShortDecimalFormat(impactValue: string): string {
    return getShortDecimalFormat(impactValue);
  }

  convertStringFunction(impactValue: string) {
    if (!impactValue || impactValue.trim() === '') {
      let doubleValue: number = parseFloat(impactValue);

      switch (true) {
        case doubleValue >= 100:
          impactValue = Math.round(parseFloat(impactValue)).toString();
          break;

        case doubleValue >= 1 && doubleValue < 100:
          impactValue = parseFloat(impactValue).toFixed(1).toString();
          break;

        case doubleValue >= 0.1 && doubleValue < 1:
          impactValue = parseFloat(impactValue).toFixed(2).toString();
          break;

        case doubleValue > 0:
          impactValue = this.decimalPipe.transform(impactValue, '0.00E+00') || '';
          break;

        case doubleValue <= -100:
          impactValue = Math.round(parseFloat(impactValue)).toString();
          break;

        case doubleValue <= -1 && doubleValue > -100:
          impactValue = parseFloat(impactValue).toFixed(1).toString();
          break;

        case doubleValue <= -0.1 && doubleValue > -1:
          impactValue = parseFloat(impactValue).toFixed(2).toString();
          break;

        case doubleValue < 0:
          impactValue = this.decimalPipe.transform(impactValue, '0.00E+00') || '';
          break;

        case doubleValue == 0:
          impactValue = '0';
          break;

        default:
          impactValue = parseFloat(impactValue).toFixed(2).toString();
          break;
      }
    }
    return this.helper.convertStringFunction(impactValue);
  }

  getHideShowIncludedSection(name: any) {
    if (!!this.processIncluded) {
      const accessdData = this.processIncluded.find((data: any) => {
        return data.name == name;
      });
      if (!!accessdData) {
        return accessdData.selected;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  getComponenttransportationItems(data: any) {
    return data.some((item: any) => {
      return item.componenttransportationItems && item.componenttransportationItems.length > 0;
    });
  }

  getIngrientInfo(detail: any, items: any) {
    this.transportDetail = { details: detail, items: items };
  }
}
